import React, {Component} from 'react'
import {ListGroup} from "reactstrap";
import Post from "../../../Component/PostList/Post/Post";
import firebase from "../../../Config/firebase";
import {isAuth} from "../../../Utils/firebaseUtils";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {MDBBtn, MDBCardBody, MDBCol, MDBContainer, MDBRow} from "mdbreact";
import classes from "../../../Layout/ViewPost/ViewPost.module.css";

const db = firebase.firestore()

class MyPost extends Component {
    constructor(props) {
        super(props);
        this.state = {
            myPost: []
        }
    }

    componentDidMount() {
        if (isAuth(this.props.auth)) {
            this.getMyPostByID(this.props.auth.uid)
        }
    }

    getMyPostByID = async (uid) => {
        db.collection('Post')
            .where('createUserID', '==', uid)
            .where("isPublish", "==", true)
            .get()
            .then(docs => {
                let allPost = []
                docs.forEach((doc) => {
                    allPost.push({
                        id: doc.id,
                        ...doc.data()
                    })
                })
                this.setState({
                    myPost: allPost,
                    isLoaded: true
                })
            })
    }

    render() {
        return (
            <MDBContainer>
                <MDBRow>
                    <MDBCol xl={12} lg={12} md={12} sm={12} xs={12}>
                        <h1>
                            我的發文紀錄
                        </h1>
                        <ListGroup flush>
                            {
                                this.state.isLoaded ?
                                    this.state.myPost.map((post, index) => {
                                        return (
                                            <div>
                                                <Post
                                                    key={index}
                                                    data={post}
                                                />
                                            </div>

                                        )
                                    })
                                    : ''
                            }
                        </ListGroup>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        );
    }
}

const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)
export default enhance(withRouter(MyPost))